function getVer () {
	return {ver: '3.11.12', verExternal: '1.4.0', verPrd: '1.4.0'};
}
if (stage.ver) {
	if (stage.ver != getVer().ver) {
		stage.upgrade = true;
	} else {
		trace('已是最新版本');
	}
} else {
	$.extend(stage, getVer());
}



//////////////////
// WEBPACK FOOTER
// ./static/js/upgrade.js
// module id = eyOS
// module chunks = 264